/* @ngInject */
const metadata = (
  railwayLabels,
  railwayFields,
  railwayButtons
) => {
  const self = {}

  self.favoriteSort = ['areaName', 'number',]

  self.badges = [{
    color: () => 'badge-garage-franc',
    label: railwayLabels.badges.full,
    display: _railway => _railway.availableLength < 0,
  },]

  self.buttons = [
    railwayButtons.search,
    railwayButtons.edit,
    railwayButtons.delete,
  ]

  self.fields = railwayFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/metadata.service.js